import {
  Directive,
  ElementRef,
  forwardRef,
  Host,
  HostListener,
  Inject,
  Optional,
  Renderer2
} from '@angular/core';
import { ListKeyManagerOption } from '@angular/cdk/a11y';
import { DOCUMENT } from '@angular/common';
import { ENTER } from '@angular/cdk/keycodes';
import {MatRadioGroup} from '@angular/material';
import {JdSelectComponent} from '../select/jd-select.component';
import {NzDatePickerComponent} from "../date-picker/date-picker.component";
import {NzRangePickerComponent} from "../date-picker/range-picker.component";

export interface FocusAbleOption extends ListKeyManagerOption {
  focus(): void;
}

@Directive({
  selector: '[jd-form-focus]',
  exportAs: 'jdFormFocus'
})
export class FormFocusDirective implements FocusAbleOption {
  private _pickDateEvent: () => void;
  private _pickDateBlurEvent: () => void;

  private _jdSelectOpenChangeEvent;

  constructor(
    private element: ElementRef,
    private _render: Renderer2,
    @Inject(DOCUMENT) private _document: any,
    @Host()
    @Optional()
    @Inject(forwardRef(() => NzDatePickerComponent))
    private _datePickCom: NzDatePickerComponent,
    @Host()
    @Optional()
    @Inject(forwardRef(() => NzRangePickerComponent))
    private _dateRangePickCom: NzRangePickerComponent,
    @Host()
    @Optional()
    @Inject(forwardRef(() => JdSelectComponent))
    private _selectCom: JdSelectComponent,
    @Host()
    @Optional()
    @Inject(forwardRef(() => MatRadioGroup))
    private _radioCom: MatRadioGroup
  ) {}

  @HostListener('keydown', ['$event'])
  OnKeydown($event) {
    const nodeName = this.element.nativeElement.nodeName;
    if (nodeName === 'NZ-DATE-PICKER' && $event.keyCode === ENTER) {
      if (!this._datePickCom.nzOpen) {
        (this._datePickCom as any)['picker'].showOverlay();
        this.focusInputPick(this.element.nativeElement.querySelector('input'));
      }
    }
    if (nodeName === 'NZ-RANGE-PICKER' && $event.keyCode === ENTER) {
      if (!this._dateRangePickCom.nzOpen) {
        (this._dateRangePickCom as any)['picker'].showOverlay();
        this.focusInputRangePick(
          this.element.nativeElement.querySelector('.ant-calendar-picker')
        );
      }
    }
  }

  focus() {
    const nodeName = this.element.nativeElement.nodeName;
    if (nodeName === 'INPUT') {
      this.element.nativeElement.focus();
    }
    // console.log(nodeName);
    if (nodeName === 'JD-SELECT') {
      const _el = this.element.nativeElement.children[0];
      if (this._selectCom.jdSelectTopControlComponent.inputElement) {
        this._selectCom.focus();
      } else {
        _el.focus();
      }
      _el['JD-SELECT'] = 'JD-SELECT';
      _el['JD-SELECT-OPEN'] = false;
      if (!this._jdSelectOpenChangeEvent) {
        this._jdSelectOpenChangeEvent = this._selectCom.jdOpenChange.subscribe(
          v1 => {
            _el['JD-SELECT-OPEN'] = v1;
            console.log(_el['JD-SELECT-OPEN']);
          }
        );
      }
    }
    if (nodeName === 'NZ-DATE-PICKER') {
      const _input = this.element.nativeElement.querySelector('input');
      _input['NZ-DATE-PICKER'] = 'NZ-DATE-PICKER';
      // (this._datePickCom as any)['picker'].showOverlay();
      _input.focus();
      this.focusInputPick(_input);
    }
    if (nodeName === 'NZ-RANGE-PICKER') {
      const _input = this.element.nativeElement.querySelector(
        '.ant-calendar-picker'
      );

      _input['NZ-RANGE-PICKER'] = 'NZ-RANGE-PICKER';
      // (this._dateRangePickCom as any)['picker'].showOverlay();
      _input.focus();
      this.focusInputRangePick(_input);
    }

    if (nodeName === 'MAT-RADIO-GROUP' && this._radioCom._radios.toArray()[0]) {
      this._radioCom._radios.toArray()[0].focus();
    }
  }
  focusInputRangePick(_input) {
    setTimeout(() => {
      const _inputEl = <any>(
        this._document.querySelector('calendar-input .ant-calendar-input')
      );
      if (_inputEl) {
        _inputEl.focus();
        this._pickDateEvent = this._render.listen(
          _inputEl,
          'keydown',
          (event: KeyboardEvent) => {
            if (event.keyCode === ENTER) {
              this._dateRangePickCom.closeOverlay();
              _input.focus();
            }
          }
        );
      }
    }, 10);
  }

  focusInputPick(_input) {
    setTimeout(() => {
      const _inputEl = <any>(
        this._document.querySelector('calendar-input .ant-calendar-input')
      );
      if (_inputEl) {
        _inputEl.focus();
        this._pickDateEvent = this._render.listen(
          _inputEl,
          'keydown',
          (event: KeyboardEvent) => {
            if (event.keyCode === ENTER) {
              this._datePickCom.closeOverlay();
              _input.focus();
            }
          }
        );
      }
    }, 10);
  }
}
